var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualAssoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 12,
    fill: "#9AEBA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5756 26.95L41.0398 29.4175L17.2358 53.2H14.824V50.785L38.5756 26.95ZM48.0133 11.2C47.3579 11.2 46.6763 11.4625 46.1782 11.9612L41.3807 16.765L51.2116 26.6087L56.0091 21.805C57.0315 20.7812 57.0315 19.075 56.0091 18.1037L49.8746 11.9612C49.3503 11.4362 48.6949 11.2 48.0133 11.2ZM38.5756 19.5737L9.58081 48.6062V58.45H19.4118L48.4065 29.4175L38.5756 19.5737Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualAssoc);
export default __webpack_public_path__ + "static/media/manualAssoc.cc2e6c82565fef86bb0e0047a1bc1c72.svg";
export { ForwardRef as ReactComponent };